import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ContactSelfServiceFormsService } from 'src/app/form/contact-self-service-forms/contact-self-service-forms.service';
@Pipe({
  name: 'safehtml',
})
export class SafehtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: string): SafeHtml | null {
    if(value) {
      const val = value.replace(/\\/g, '');
      return this.sanitized.bypassSecurityTrustHtml(ContactSelfServiceFormsService.sanitizeHtml(val));
    }
    return null;
  }
}
